import classNames from 'classnames';
import { getActivityStatus } from 'utils';
import { isCHFReading } from 'utils/get-reading-info';
import CHFRenalStatus from 'components/atoms/chf-renal-status';
import useUser from 'utils/useUser';
import { ReadingStatus, ReadingType } from 'infrastructure/enums';

import s from './styles.module.scss';
import RecoveredStatus from './recovered-status';

import type { TThresholdName } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

interface StatusProps {
  globalStatus: ReadingStatus;
  thresholdName?: TThresholdName | null;
  isRecovered?: boolean;
  wrapperClassName?: string;
  readingType: ReadingType;
}

const Status: FC<StatusProps> = ({
  globalStatus,
  thresholdName,
  isRecovered,
  wrapperClassName,
  readingType,
}) => {
  const { hasRNRole } = useUser();
  const status = getActivityStatus(globalStatus);
  const isCHF = isCHFReading(thresholdName);
  const showCHFLabel = !isRecovered && thresholdName && isCHF && hasRNRole;

  const showWeightMgmtLabel =
    !isCHF &&
    globalStatus === ReadingStatus.Critical &&
    readingType === ReadingType.Weight;

  return (
    <div className={wrapperClassName}>
      <p
        data-cy="reading-status"
        className={classNames(s.status, s[`status-${globalStatus}`])}
      >
        {status}
      </p>
      {isRecovered && <RecoveredStatus />}
      {showCHFLabel && <CHFRenalStatus isSubStatus />}
      {showWeightMgmtLabel && <CHFRenalStatus isSubStatus label="weightMgmt" />}
    </div>
  );
};
export default Status;
